import { createSelector } from 'reselect';
import { getCompanySettings } from './getCompanySettings';
import { getIsMESEnabled } from './getIsMESEnabled';

/** Returns true when production schedule feature is enabled (always true for MES-enabled machines). */
export const getProductionScheduleEnabled = createSelector(
  [getCompanySettings, getIsMESEnabled],
  (companySettings, mesEnabled) => {
    if (mesEnabled) return true;
    return companySettings?.productionScheduleEnabled ?? false;
  }
);
